export enum BookkeepersTableAccessors {
  Bookkeeper = 'bookkeeper',
  RemoveBookkeeper = 'remove-bookkeeper',
}
